module.exports = __webpack_public_path__ + "static/media/split-cards.f5990a4c.svg";